module.exports = __webpack_public_path__ + "img/email.07184974.svg";